import { usStatesList } from "..//usStatesList";

export const ccpa = {
  title: "Personal Information Request Form for California Residents",
  header_1:
    'To exercise your rights under the California Consumer Protection Act ("CCPA"), please submit a verifiable consumer request to us by filling out the following form or emailing us with the information requested in the form below at ',
  link: "privacy@demystdata.com",
  link_target: "privacy@demystdata.com",
  header_2:
    ". Please note, only you, or a person who you authorize to act on your behalf, may make a verifiable consumer request related to your personal information.",
  paragraph_1:
    "Demyst Data will not discriminate against you for exercising any of your CCPA rights.",
  paragraph_2:
    'You may also opt out of the sharing or "sale" of your Personal Information by selecting the "Opt out of the sale of my Personal Information" option below consistent with applicable law. Please note, California’s definition of "sale" includes transfers that ordinarily may not be thought of as a "sale" in the traditional sense – such as sharing information with our affiliates.',
  fields: [
    {
      label: "Select one or more of the following:",
      id: "categories",
      component: "multiplechoice",
      options: [
        "Deletion of my Personal Information",
        "Opt out of the sale of my Personal Information",
        "Access to a port or copy of my Personal Information",
      ],
      required: true,
    },
    { label: "Full name", id: "full_name", type: "text", component: "input", required: true },
    { label: "Email address", id: "email", type: "email", component: "input", required: true },
    { label: "Street", id: "address", type: "text", component: "input", required: true },
    { label: "City", id: "city", type: "text", component: "input", required: true },
    { label: "Postal code", id: "postal_code", type: "text", component: "input", required: true },
    {
      label: "State",
      id: "state",
      type: "select",
      component: "select",
      placeholder: "Select a state",
      options: usStatesList,
      required: true,
    },
    {
      label: "",
      id: "residency",
      component: "singlechoice",
      options: [
        "A California resident exercising the rights afforded to me under the CPA, or",
        "The agent of a California resident, who has authorized the requires on their behalf, and that I have verified their identity, obtained a valid certification from the California Secretary of State and have complied with all applicable laws and regulations.",
      ],
      required: false,
    },
  ],
  form: {
    label: "ALL FIELDS ARE REQUIRED",
    title: "Personal Information Request Form",
    residency: {
      header:
        "By submitting this request, I verify under perjury that the Information I am requesting and submitting is true and correct and that I am:",
      footer:
        "I understand that my request will not be performed until my identity (or the identity and authority of anyone who may attempt to act my behalf) is verified in accordance with applicable law.",
    },
    button_text: "Submit",
  },
  errors: {
    field_required: "This field is required!",
    incorrect_mail: "This email address is incorrect.",
  },
};
